<template>
    <!--
    Code By     : 陈伦刚
    CreateTime  : 2021-04-08 04:54:04
    Description : 富文本展示
  -->
    <div class='background'>
        <div class='main'>
            <div class='left'>
                <div
                    class='logo'
                    :style="{
                        background: `url(${logo})`,
                        backgroundSize: 'cover',
                    }"
                ></div>
                <div class='tab'>
                    <div
                        v-for='(item, i) in tabsList'
                        :key='item + i'
                        class='item'
                        :class='{ active: index === i }'
                    >
                        <div v-if="item !== '线上集训'" @click='tabClick(i)'>
                            {{ item }}
                            <div
                                v-if='i !== tabsList.length - 1'
                                style='
                                    background: #f5f5f5;
                                    height: 2px;
                                    width: 100%;
                                    margin-top: 20px;
                                '
                            ></div>
                            <div style='height: 20px'></div>
                        </div>
                        <div v-else style='margin-top: -6px'>
                            <el-dropdown
                                trigger='click'
                                @command='tabClick2'
                                placement='bottom-start'
                            >
                                <span class='el-dropdown-link'>
                                    <span
                                        style='font-size: 16px; color: #000000'
                                    >
                                        {{ item }}
                                    </span>
                                    <i
                                        class='
                                            el-icon-arrow-down
                                            el-icon--right
                                        '
                                    ></i>
                                </span>
                                <el-dropdown-menu
                                    slot='dropdown'
                                    style='width: 182px; margin-left: -10px'
                                >
                                    <el-dropdown-item
                                        v-for='(item, i) in onlineClass'
                                        :key='item.id'
                                        :command='i'
                                    >
                                        {{ item.title }}
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </div>
            </div>
            <div class='right'>
                <div
                    v-if='ifShowBanner'
                    class='banner'
                    :style='{
                        background: `url(${bannerCoverList[index]})`,
                    }'
                >
                    <span
                        v-if="
                            path.includes('/gaia-48/party-night') ||
                            path.includes('/gaia-48/news')
                        "
                    >
                        官方发布
                        <div
                            style='
                                font-size: 14px;
                                margin-top: -60px;
                                margin-left: -10px;
                                letter-spacing: 1px;
                            '
                        >
                            Release & Report
                        </div>
                    </span>
                </div>
                <div
                    v-if="!path.includes('/gaia-48/news')"
                    class='content'
                    v-html='content'
                />
                <div v-else class='content'>
                    <div
                        v-if='index === 0 && !showNewContent'
                        style='min-height: 300px'
                    >
                        <h1 style='font-weight: 500; margin: 20px 0 70px'>
                            官方发布
                        </h1>
                        <div
                            class='flex'
                            v-for='(item, i) in newsList'
                            :key='item.id'
                            style='margin: 10px 0 30px'
                        >
                            <div class='img'>
                                <img
                                    class='img'
                                    :src='VUE_APP_RESOURCES_URL + item.cover'
                                    @click='openNewContent(item.id)'
                                />
                            </div>
                            <div class='info'>
                                <div class='title'>{{ item.title }}</div>
                                <div class='date'>
                                    发布于{{
                                        $dayjs(item.createTime).format(
                                            'YYYY/MM/DD hh:mm:ss',
                                        )
                                    }}
                                </div>
                            </div>
                            <div
                                class='info'
                                style='width: 200px; text-align: right'
                            >
                                <good-one
                                    :theme="item.isLike ? 'filled' : 'outline'"
                                    size='40'
                                    fill='#ffa100'
                                    style='cursor: pointer'
                                    @click='newsAgree(item.id)'
                                />
                            </div>
                        </div>
                        <div style='padding: 100px 0 100px'>
                            <el-pagination
                                background
                                layout='prev, pager, next'
                                :page-size='page.pageSize'
                                :total='page.total'
                                :current-page='page.pageIndex'
                                @current-change='getAllNews'
                            />
                        </div>
                    </div>
                    <div
                        v-if='index === 0 && showNewContent'
                        style='min-height: 300px'
                    >
                        <el-page-header
                            @back='showNewContent = !showNewContent'
                            content='列表页面'
                            style='margin-top: -30px'
                        />
                        <div style='height: 20px'></div>
                        <div v-html='newsContent' v-loading='newsLoading'></div>
                    </div>
                    <div v-if='index === 1' style='min-height: 300px'>
                        <h1 style='font-weight: 500; margin: 20px 0 70px'>
                            相册
                        </h1>
                        <div
                            class='flex2'
                            v-for='(item, i) in photosList'
                            :key='item.id'
                        >
                            <div class='img'>
                                <!-- <img
                  class="img"
                  :src="VUE_APP_RESOURCES_URL + item.cover"
                  @click="getPhotoDetails(item.ablum.id)"
                /> -->
                                <gaia-viewer
                                    v-loading='loading'
                                    :imgs='item.urls'
                                />
                            </div>
                            <div class='info'>
                                <div class='title'>{{ item.ablum.name }}</div>
                                <div class='date'>
                                    发布于{{
                                        $dayjs(item.ablum.createTime).format(
                                            'YYYY/MM/DD hh:mm:ss',
                                        )
                                    }}
                                </div>
                            </div>
                        </div>
                        <div style='padding: 100px 0 100px'>
                            <el-pagination
                                background
                                layout='prev, pager, next'
                                :page-size='page.pageSize'
                                :total='page.total'
                                :current-page='page.pageIndex'
                                @current-change='getAblums'
                            />
                        </div>
                        <el-dialog
                            title='相册详情'
                            width='900px'
                            :visible.sync='imgsVisible'
                        >
                            <div class='viewer-box'></div>
                        </el-dialog>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getPartyNight,
        get48info,
        getTrainSettings,
        getAllNews,
        getAblums,
        getPhotoDetails,
        getOnlineClass,
        newsAgree,
        getNewsDetail,
    } from '@/api/newgaia48'
    import gaiaViewer from '@/components/gaia-viewer/gaia-viewer.vue'
    import { GoodOne } from '@icon-park/vue'

    export default {
        components: { gaiaViewer, GoodOne },
        data() {
            return {
                baseUrl: process.env.VUE_APP_RESOURCES_URL,
                OLD_RESOURCES_URL: 'https://qw.gaiamount.com/',
                OLD_RESOURCES_URL2: 'https://48.gaiamount.com/',
                VUE_APP_RESOURCES_URL: process.env.VUE_APP_RESOURCES_URL,
                VUE_APP_RESOURCES_URL2:
                    'https://pub-glb.cn-e1.acs-cdn.gaiamount.com/',
                logo: require('@/assets/images/gaia48/gaia48-3.png'),
                logo1: require('@/assets/images/gaia48/gaia48-1.png'),
                logo2: require('@/assets/images/gaia48/gaia48-2.png'),
                logo3: require('@/assets/images/gaia48/gaia48-3.png'),
                index: 0,
                tabsList: ['', '', '', ''],
                contentList: ['', '', '', '', ''],
                bannerCoverList: [],
                path: '',
                ifShowBanner: true,
                page: {
                    pageIndex: 1,
                    pageSize: 5,
                    total: 0,
                },
                newsList: [],
                photosList: [],
                imgsVisible: false,
                imgsList: [],
                loading: false,
                onlineClass: [],
                showNewContent: false,
                newsContent: '',
                newsLoading: false,
            }
        },
        created() {
            this.path = this.$route.path
            if (this.$route.query.index) {
                this.index = Number(this.$route.query.index)
            }
            if (this.path.includes('/gaia-48/info')) {
                this.logo = this.logo2
                this.get48info()
            } else if (this.path.includes('/gaia-48/introduce')) {
                this.logo = this.logo1
                this.getTrainSettings()
                this.getOnlineClass()
            } else if (this.path.includes('/gaia-48/party-night')) {
                this.logo = this.logo1
                this.getPartyNight()
            } else if (this.path.includes('/gaia-48/news')) {
                this.logo = this.logo3
                if (this.index === 0) {
                    this.getAllNews()
                } else if (this.index === 1) {
                    this.getAblums()
                }
            }
            console.log(this.path)
        },
        methods: {
            tabClick(i) {
                this.index = i
                if (this.path.includes('/gaia-48/news')) {
                    if (i === 0) {
                        this.getAllNews()
                    } else if (i === 1) {
                        this.getAblums()
                    }
                } else {
                    this.content = this.contentList[i]
                }
            },
            tabClick2(i) {
                this.index = 1
                this.content = this.onlineClass[i].content
            },
            get48info() {
                get48info().then((res) => {
                    this.tabsList = [
                        'Gaia48',
                        '竞赛细则',
                        '奖项设置',
                        '评审团',
                        '日程安排',
                    ]
                    this.contentList = [
                        res.settings.content,
                        res.settings.competitionRules,
                        res.settings.awardsContent,
                        res.settings.jury,
                        res.settings.schedule,
                    ]
                    this.bannerCoverList = [
                        this.OLD_RESOURCES_URL2 +
                        '/static/img/ac-main-title.3bc22ed.png',
                        this.OLD_RESOURCES_URL2 +
                        '/static/img/ac-main-title.3bc22ed.png',
                        this.OLD_RESOURCES_URL2 +
                        '/static/img/ac-main-title.3bc22ed.png',
                        this.OLD_RESOURCES_URL2 +
                        '/static/img/ac-main-title.3bc22ed.png',
                        this.OLD_RESOURCES_URL2 +
                        '/static/img/ac-main-title.3bc22ed.png',
                    ]
                    this.tabClick(this.index)
                })
            },
            getTrainSettings() {
                this.tabsList = ['介绍', '线上集训', '线下集训', '公开课']
                getTrainSettings().then((res) => {
                    this.contentList = [
                        res.trainingSettings.info,
                        res.trainingSettings.offlineSignUpAddress,
                        res.trainingSettings.offlineContent,
                        res.trainingSettings.publicClassContent,
                    ]
                    this.bannerCoverList = [
                        this.VUE_APP_RESOURCES_URL2 +
                        res.trainingSettings.bannerCover,
                        this.VUE_APP_RESOURCES_URL2 +
                        res.trainingSettings.bannerCover,
                        this.VUE_APP_RESOURCES_URL2 +
                        res.trainingSettings.bannerCover,
                        this.VUE_APP_RESOURCES_URL2 +
                        res.trainingSettings.bannerCover,
                    ]
                    this.tabClick(this.index)
                })
            },
            getPartyNight() {
                this.tabsList = ['播映', '颁奖', '设备展', 'Party']
                getPartyNight().then((res) => {
                    this.contentList = [
                        res.partyNight[0].content,
                        res.partyNight[1].content,
                        res.partyNight[2].content,
                        res.partyNight[3].content,
                    ]
                    this.bannerCoverList = [
                        this.VUE_APP_RESOURCES_URL +
                        res.partyNight[0].bannerCover,
                        this.VUE_APP_RESOURCES_URL +
                        res.partyNight[1].bannerCover,
                        this.VUE_APP_RESOURCES_URL +
                        res.partyNight[2].bannerCover,
                        this.VUE_APP_RESOURCES_URL +
                        res.partyNight[3].bannerCover,
                    ]
                    this.tabClick(this.index)
                })
            },
            getAllNews(pageIndex = 1) {
                this.tabsList = ['官方发布', '相册']
                this.page.pageIndex = pageIndex
                this.bannerCoverList = [
                    'https://pub-glb.cn-e1.acs-cdn.gaiamount.com/smallFile/4/1513670970345cf1f.jpg',
                    'https://pub-glb.cn-e1.acs-cdn.gaiamount.com/smallFile/4/1513670970345cf1f.jpg',
                ]
                getAllNews(this.page).then((res) => {
                    console.log('新闻', res)
                    this.newsList = res.newsDtos
                })
            },
            getAblums(pageIndex = 1) {
                this.tabsList = ['官方发布', '相册']
                this.page.pageIndex = pageIndex
                this.bannerCoverList = [
                    'https://pub-glb.cn-e1.acs-cdn.gaiamount.com/smallFile/4/1513670970345cf1f.jpg',
                    'https://pub-glb.cn-e1.acs-cdn.gaiamount.com/smallFile/4/1513670970345cf1f.jpg',
                ]
                getAblums(this.page).then((res) => {
                    console.log('相册', res)
                    this.photosList = res.ablumDtos.map((el) => {
                        return {
                            ablum: el.ablum,
                            count: el.count,
                            cover: el.cover,
                            urls: el.urls.map((el) => {
                                return this.baseUrl + el
                            }),
                        }
                    })
                })
            },
            getPhotoDetails(id) {
                this.loading = true
                this.imgsVisible = true
                this.imgsList = []
                const data = {
                    pageIndex: 1,
                    pageSize: 1000,
                    id: id,
                }
                getPhotoDetails(data)
                    .then((res) => {
                        this.imgsList = res.photoList.map((el) => {
                            return el.url
                        })
                        this.loading = false
                        setTimeout(() => {
                            this.$forceUpdate()
                        }, 1000)
                    })
                    .catch((err) => {
                        this.loading = false
                        this.$forceUpdate()
                    })
            },
            getOnlineClass() {
                getOnlineClass({ pageIndex: 1, pageSize: 100 }).then((res) => {
                    console.log(res)
                    this.onlineClass = res.onlineClass
                })
            },
            newsAgree(id) {
                newsAgree(id).then((res) => {
                    this.getAllNews(this.page.pageIndex)
                    if (res.msg.includes('cancel')) {
                        this.$message.success('取消点赞成功')
                    } else {
                        this.$message.success('点赞成功')
                    }
                })
            },
            openNewContent(id) {
                this.newsContent = ''
                this.showNewContent = true
                this.newsLoading = true
                getNewsDetail(id)
                    .then((res) => {
                        console.log(res.news)
                        this.newsContent = res.news.content
                        this.newsLoading = false
                    })
                    .catch((err) => {
                        this.newsLoading = false
                    })
            },
        },
    }
</script>
<style lang='less'>
    .content {
        a {
            color: #ffa200;
        }
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #ffa200;
    }

    img {
        max-width: 100%;
    }
</style>
<style lang='less' scoped>
    .background {
        width: 100%;
        min-width: 1300px;
        min-height: 650px;
        background: #f5f5f5;
    }

    .main {
        display: flex;
        justify-content: space-between;
        width: 1300px;
        min-width: 1300px;
        margin: 0px auto;
        padding: 160px 50px 0;

        .left {
            width: 15%;

            .logo {
                width: 100%;
                height: 220px;
            }

            .tab {
                width: 100%;
                border-radius: 4px;
                padding: 1px 0;
                margin: 0px 0 20px;
                background: #ffffff;

                .item {
                    height: 20px;
                    margin: 14px 0;
                    line-height: 0px;
                    padding: 10px;
                    font-size: 16px;
                    cursor: pointer;
                    transition: all 0.4;
                }

                .item.active {
                    padding-left: 5px;
                    border-left: 5px solid #ffa200;
                    transition: all 0.4;
                }
            }
        }

        .right {
            width: 83%;
            margin-bottom: 40px;

            .banner {
                width: 100%;
                height: 110px;
                line-height: 90px;
                font-size: 30px;
                letter-spacing: 10px;
                color: #ffffff;
                text-align: center;
                background: #ffffff;
            }

            .content {
                width: 100%;
                min-height: 440px;
                padding: 60px;
                border-radius: 4px;
                background: #ffffff;
            }
        }
    }

    .flex {
        display: flex;

        .img {
            width: 300px;
            height: 150px;
            margin-right: 20px;
            cursor: pointer;
        }

        .info {
            padding: 10px 0;

            .title {
                width: 370px;
                height: 110px;
                font-size: 22px;
                color: #000000;
            }

            .date {
                font-size: 16px;
                color: #7f7f7f;
            }
        }
    }

    .flex2 {
        display: inline-block;
        width: 286px;
        margin-left: 20px;

        .img {
            width: 278px;
            height: 278px;
            margin-right: 20px;
            border: solid #eeeeee 1px;
            padding: 4px;
            cursor: pointer;
        }

        .info {
            .title {
                height: 30px;
                line-height: 30px;
                font-size: 22px;
                margin: 10px 0;
                color: #000000;
                overflow: hidden; //超出的文本隐藏
                text-overflow: ellipsis; //溢出用省略号显示
                white-space: nowrap; //溢出不换行
            }

            .date {
                font-size: 16px;
                color: #7f7f7f;
            }
        }
    }

    .flex2:nth-child(n) {
        margin: 0;
    }

    .viewer-box {
        max-height: 600px;
        overflow-y: auto;
    }
</style>
